"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isApprovedForSpender = exports.compareERC20Info = exports.compareTokenAddresses = exports.compareTokenAddress = exports.compareNFTs = exports.getRandomNFTID = void 0;
const ethers_1 = require("ethers");
const shared_models_1 = require("@railgun-community/shared-models");
const getRandomNFTID = () => {
    const randomHex = Buffer.from((0, ethers_1.randomBytes)(32)).toString('hex');
    return BigInt(`0x${randomHex}`);
};
exports.getRandomNFTID = getRandomNFTID;
const compareNFTs = (a, b) => {
    return ((0, exports.compareTokenAddress)(a.nftAddress, b.nftAddress) &&
        a.nftTokenType === b.nftTokenType &&
        BigInt(a.tokenSubID) === BigInt(b.tokenSubID) &&
        a.amount === b.amount);
};
exports.compareNFTs = compareNFTs;
const compareTokenAddress = (a, b) => {
    if (!a || !b) {
        return false;
    }
    return a.toLowerCase() === b.toLowerCase();
};
exports.compareTokenAddress = compareTokenAddress;
const compareTokenAddresses = (list, b) => {
    if (!list.length || !b) {
        return false;
    }
    return list.find(a => (0, exports.compareTokenAddress)(a, b)) != null;
};
exports.compareTokenAddresses = compareTokenAddresses;
const compareERC20Info = (tokenA, tokenB) => {
    return ((0, exports.compareTokenAddress)(tokenA.tokenAddress, tokenB.tokenAddress) &&
        (tokenA.isBaseToken ?? false) === (tokenB.isBaseToken ?? false));
};
exports.compareERC20Info = compareERC20Info;
const isApprovedForSpender = (erc20Amount, spender) => {
    return !(0, shared_models_1.isDefined)(spender) || erc20Amount.approvedSpender === spender;
};
exports.isApprovedForSpender = isApprovedForSpender;
